import { Switch } from '@headlessui/react'
import { createVariants } from 'shared-ui/lib'
import { isNonNil } from 'utils'

type Props = {
  checked: boolean
  onChange: (val: boolean) => void
  screenReaderLabel?: string
  colorOverride?: {
    unchecked: string
    checked: string
  }
  thin?: boolean
  disabled?: boolean
}

export const ToggleSwitch: React.FC<Props> = ({
  checked,
  onChange,
  screenReaderLabel,
  colorOverride = {
    checked: 'bg-green',
    unchecked: 'bg-gray-200'
  },
  thin = false,
  disabled = false
}) => (
  <Switch
    checked={checked}
    onChange={onChange}
    className={styledSwitchClasses({
      thin,
      className: `${checked ? colorOverride.checked : colorOverride.unchecked} ${disabled ? `cursor-not-allowed opacity-50` : ``}`
    })}
    disabled={disabled}
  >
    {isNonNil(screenReaderLabel) && <span className="sr-only">{screenReaderLabel}</span>}
    <span className={styledToggleMarkerClasses({ thin, active: checked })} />
  </Switch>
)

const styledSwitchClasses = createVariants({
  base: 'relative inline-flex items-center rounded-full',
  variants: {
    thin: {
      true: 'h-4 w-8',
      false: 'h-6 w-11'
    }
  },
  defaultVariants: {
    thin: false
  }
})

const styledToggleMarkerClasses = createVariants({
  base: 'inline-block transform rounded-full bg-white transition',
  variants: {
    active: { true: '', false: 'translate-x-1' },
    thin: { true: 'size-3', false: 'size-4' }
  },
  defaultVariants: {
    thin: false
  },
  compoundVariants: [
    {
      active: true,
      thin: true,
      className: 'translate-x-4'
    },
    {
      active: true,
      thin: false,
      className: 'translate-x-6'
    }
  ]
})
